import { CloseIcon, PlusIcon } from "components/atoms/Icon";
import InputFieldWithLabel from "components/molecules/forms/InputFieldWithLabel";
import TextAreaWithLabel from "components/molecules/forms/TextAreaWithLabel";
import { useFieldArray, useFormContext } from "react-hook-form";

export default function PollQuestion({ isPollPublished, qId }: { isPollPublished: boolean; qId: number }) {
  const {
    register,
    formState: { errors },
    control,
  } = useFormContext<PollFormDataNew>();

  const {
    fields: choices,
    append: appendChoice,
    remove: removeChoice,
    // @ts-ignore
  } = useFieldArray({ control, name: `questions.[${qId}].choices` });
  return (
    <div className="my-8 rounded-2xl bg-neutral-400 bg-opacity-5 px-6 py-4">
      <TextAreaWithLabel
        label={`Question ${qId + 1}`}
        isDisabled={isPollPublished}
        id={`questions.[${qId}].question`}
        labelClasses="text-xxs 2xl:text-xs"
        additionalClasses="text-xs 2xl:text-sm"
        rows={2}
        placeHolder="Enter your poll question here"
        register={register}
        defaultValue=""
        errorMessage={errors?.questions?.[qId]?.question?.message}
      />

      {choices.map((field, idx: number) => (
        <div key={`choices-${field.id}`} className="relative">
          <InputFieldWithLabel
            label=""
            id={`questions.[${qId}].choices.[${idx}].text`}
            isDisabled={isPollPublished}
            register={register}
            labelClasses="text-xxs 2xl:text-xs"
            additionalClasses="text-xs 2xl:text-sm"
            placeHolder={`Enter Choice ${idx + 1}`}
            errorMessageClasses="mt-0"
            errorMessage={errors?.questions?.[qId]?.choices?.[idx]?.text?.message}
          />

          <div className="absolute right-3 top-4">
            <button
              disabled={idx < 2 || isPollPublished}
              type="button"
              className="disabled:hidden"
              onClick={() => removeChoice(idx)}
            >
              <CloseIcon className="h-3 w-3 text-red-600" />
            </button>
          </div>
        </div>
      ))}
      <div className="flex justify-center">
        <button
          type="button"
          // user is not allowed to add options if poll is published
          disabled={choices.length >= 5 || isPollPublished}
          className="rounded-full bg-secondary p-3 disabled:hidden 2xl:p-4"
          // @ts-ignore
          onClick={() => appendChoice({ text: "" })}
        >
          <PlusIcon className="h-3 w-3 2xl:h-4 2xl:w-4" />
        </button>
      </div>
    </div>
  );
}
